import { request, withQuery } from './client';
import type { PriceTypeItem, SaleCard, SaleFindItem, SaleInput, SalePreviewInput, SalePreviewResult, SaleResult, SaleReturnInput, SaleReturnResult, SaleCancelInput, SaleCancelResult, NoReceiptReturnInput } from '@kassa/shared';

export const salesApi = {
  sale: (body: SaleInput) => request<SaleResult>('POST', '/api/sales', body),
  salePreview: (body: SalePreviewInput) => request<SalePreviewResult>('POST', '/api/sales/preview', body),
  salePriceTypes: () => request<PriceTypeItem[]>('GET', '/api/sales/price-types'),
  saleFind: (q: string) => request<SaleFindItem[]>('GET', withQuery('/api/sales', { q })),
  saleCard: (id: string) => request<SaleCard>('GET', `/api/sales/${encodeURIComponent(id)}`),
  saleReturn: (id: string, body: SaleReturnInput) =>
    request<SaleReturnResult>('POST', `/api/sales/${encodeURIComponent(id)}/return`, body),
  saleReturnNoReceipt: (body: NoReceiptReturnInput) => request<SaleReturnResult>('POST', '/api/sales/returns', body),
  saleCancel: (id: string, body: SaleCancelInput) =>
    request<SaleCancelResult>('POST', `/api/sales/${encodeURIComponent(id)}/cancel`, body),
};
